import React from 'react';

import DataInfo from '../dataInfo/dataInfo.component';

const SelectContextDataInfo = () => <DataInfo textToRender={'Please select context data'} />;

export default SelectContextDataInfo;
